// extracted by mini-css-extract-plugin
export default {"sidebarItemHover":"sidebar_sidebarItemHover__Obpy7","navlabel":"sidebar_navlabel__DazwC","iconHover":"sidebar_iconHover__kMVDT","sidebarLink":"sidebar_sidebarLink__QY7hJ"};